<script lang="ts" setup>
import { getMetaTags } from '~/utils/meta'
import type { BreadcrumbItem } from '@nuxt/ui'
import { infographicImages } from '~/models/images'
import { heroImages } from '#shared/models/images'

definePageMeta({
  layout: false
})

defineRouteRules({
  prerender: true
})

const { t, baseKey } = useI18n('pages.static.onze-missie')

const heroImage = heroImages['irene-en-haar-zoon']

useSeoMeta(
  getMetaTags(
    {
      title: '.meta.title',
      description: '.meta.description'
    },
    heroImage.src,
    baseKey
  )
)

useSchemaOrg(
  getSchemaOrg(
    {
      title: '.title',
      breadcrumbs: [{ name: '.title' }]
    },
    baseKey
  )
)

const infographic2025 = infographicImages['infographic-2025']
const impactResearch2025 = infographicImages['impactonderzoek-2025']

const breadcrumbItems: BreadcrumbItem[] = [{ label: '.title', to: 'onze-missie' }]
</script>

<template>
  <div>
    <NuxtLayout
      name="default"
      title=".title"
      description=".description"
      :image="heroImage"
      :ui="{
        image: 'lg:object-[center_-5rem]'
      }"
    >
      <VBreadcrumb :items="breadcrumbItems" />

      <VSection base-key=".section-one" title=".title" description=".description">
        <template #after>
          <VModalImage :image="infographic2025" class="mt-6" />
        </template>
      </VSection>

      <QuoteSection type="quote" title=".section-two.quote" />

      <VSection base-key=".section-three" title=".title">
        <p>
          {{ t('.section-three.paragraph-one') }}
        </p>

        <p>
          {{ t('.section-three.paragraph-two') }}
        </p>

        <p>
          {{ t('.section-three.paragraph-three') }}
        </p>
      </VSection>

      <VSection base-key=".section-four" title=".title" description=".description">
        <template #after>
          <div class="mt-4">
            <ExperiencesOfOtherFoodiesSection carousel-only />
          </div>

          <p class="mt-4">
            {{ t('.section-four.paragraph-one') }}
          </p>
        </template>
      </VSection>

      <VSection base-key=".section-five" title=".title">
        <p>
          {{ t('.section-five.paragraph-one') }}
        </p>

        <p>
          {{ t('.section-five.paragraph-two') }}
        </p>

        <p>
          {{ t('.section-five.paragraph-three') }}
        </p>

        <template #after>
          <VModalImage :image="impactResearch2025" class="mt-6" />
        </template>
      </VSection>
    </NuxtLayout>
  </div>
</template>

<style scoped></style>
